import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import GlobalMetrics from './global_metrics';
import Chart from './chart';
import MetricPins from './metrics/metric_pins';
import Metrics from './metrics/metrics/metrics';
import {
  fetchOverviewSettings,
  getVrrPreferences
} from '../../redux/settings/settingAction';
import './Overview.scss';

const Overview: React.FC = () => {
  const dispatch: any = useDispatch();
  const { t } = useTranslation();
  const brandId = useSelector(getVrrPreferences)?.current_brand_id;

  useEffect(() => {
    if (brandId) {
      dispatch(fetchOverviewSettings());
    }
  }, [brandId]);

  return (
    <main className="overview-main-section">
      <section className="global-metrics-part">
        <h4>{t('overview.page.titles.global_metrics').toUpperCase()}</h4>
        <GlobalMetrics />
        <Chart />
      </section>
      <section className="global-insights-part">
        <h4>{t('overview.page.titles.global_insights').toUpperCase()}</h4>
        <MetricPins />
        <Metrics />
      </section>
    </main>
  );
};

export default Overview;
